import React, { Component } from 'react'
import { withCookies } from 'react-cookie'
import PropTypes from 'prop-types'
import { Gantt } from '@aicon-dev/caas-gantt'
import './GanttChart.scss'

class GanttChart extends Component {
    constructor(props) {
        super(props)

        this.state = {
            scaleUnit: 'week',
        }
    }

    setScaleUnit(scaleUnit) {
        this.setState({ ...this.state, scaleUnit })
    }

    render() {
        let work = false
        let hideWorkerNum = true
        if (this.props.cookies.get('project_detailReport') === 'true') {
            work = true
            hideWorkerNum = false
        }

        return (
            <div className="gantt-chart">
                <div className="gantt-chart__scale-unit">
                    <ul className="unit_btn_wrap">
                        <li
                            onClick={() => this.setScaleUnit('day')}
                            className={this.state.scaleUnit === 'day' && 'active'}>
                            일
                        </li>
                        <li
                            onClick={() => this.setScaleUnit('week')}
                            className={this.state.scaleUnit === 'week' && 'active'}>
                            주
                        </li>
                        <li
                            onClick={() => this.setScaleUnit('month')}
                            className={this.state.scaleUnit === 'month' && 'active'}>
                            월
                        </li>
                    </ul>
                </div>

                <Gantt
                    dataSource={this.props.tasks.data}
                    drawings={this.props.tasks.drawings}
                    timelapses={this.props.tasks.timelapses}
                    reportSpecialText={this.props.tasks.reportSpecialText}
                    rfis={this.props.tasks.rfis}
                    scaleUnit={this.state.scaleUnit}
                    height="calc(100vh - var(--gantt-chart-offset-top))"
                    hideWorkerNum={hideWorkerNum}
                    viewOptions={{
                        task: true,
                        work,
                        rfi: false,
                        drawing: false,
                        specialNote: false,
                        workerNum: false,
                        milestone: false,
                        timelapse: false,
                    }}
                />
            </div>
        )
    }
}

GanttChart.defaultProps = {
    tasks: {
        data: [],
        drawings: [],
        rfis: [],
        timelapses: [],
        reportSpecialText: [],
    },
}

GanttChart.propTypes = {
    tasks: PropTypes.shape({
        data: PropTypes.array,
        drawings: PropTypes.array,
        rfis: PropTypes.array,
        timelapses: PropTypes.array,
        reportSpecialText: PropTypes.array,
    }),
}

export default withCookies(GanttChart)



// WEBPACK FOOTER //
// ./Src/Components/Schedule/GanttChart.js